<template>
  <v-container class="sessao-plenaria">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form ref="form">
        <PageTitle
          icon="mdi-pencil-box-outline"
          main="Atividades Legislativas"
          sub="Sessão plenaria"
          home='/Legislativo'
        />
        <div>
          <sessao />
        </div>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Sessao from '../sessoes/index.vue'
export default {
  name: 'SessaoPlenaria',
  components: { PageTitle, Sessao },
  data: () => ({
  })
}
</script>

<style scoped>
</style>
